/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';

export default function Pagination({ data, onChangePage, pagination, t }) {
    // Array of buttons what we see on the page

    const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

    useEffect(() => {
        const numberOfPages = [];
        for (let i = 1; i <= Math.ceil(data.length / pagination.size); i++) {
            numberOfPages.push(i);
        }
        let tempNumberOfPages = [...arrOfCurrButtons];
        const currentButton = pagination.page + 1;

        let dotsInitial = '...';

        if (numberOfPages.length < 6) {
            tempNumberOfPages = numberOfPages;
        } else if (currentButton >= 1 && currentButton <= 3) {
            tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
        } else if (currentButton === 4) {
            const sliced = numberOfPages.slice(0, 5);
            tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
        } else if (currentButton > 4 && currentButton < numberOfPages.length - 2) {
            const sliced1 = numberOfPages.slice(currentButton - 2, currentButton); // sliced1 (5-2, 5) -> [4,5]
            const sliced2 = numberOfPages.slice(currentButton, currentButton + 1); // sliced1 (5, 5+1) -> [6]
            tempNumberOfPages = [
                1,
                dotsInitial,
                ...sliced1,
                ...sliced2,
                dotsInitial,
                numberOfPages.length,
            ]; // [1, '...', 4, 5, 6, '...', 10]
        } else if (currentButton > numberOfPages.length - 3) {
            const sliced = numberOfPages.slice(numberOfPages.length - 4); // slice(10-4)
            tempNumberOfPages = [1, dotsInitial, ...sliced];
        }

        setArrOfCurrButtons(tempNumberOfPages);
    }, [data.length, pagination]);

    return (
        <div className="dt-footer" style={{ border: 'none' }}>
            <div className="dt-pagination__block">
                <ul className="dt-pagination mb-0">
                    <li>
                        <button
                            type="button"
                            disabled={pagination.page === 0}
                            onClick={() => onChangePage(pagination.page - 1)}
                        >
                            <i className="icon-fi_arrow-left" />
                            {t("content_analyze.prev")}
                        </button>
                    </li>
                    {arrOfCurrButtons.map((item, index) => (
                        <li key={item + index}>
                            <button
                                type="button"
                                className={pagination.page === item - 1 ? 'active' : ''}
                                disabled={item === '...'}
                                onClick={() => onChangePage(item - 1)}
                            >
                                {item}
                            </button>
                        </li>
                    ))}
                    <li>
                        <button
                            type="button"
                            disabled={pagination.page + 1 >= data.length / pagination.size}
                            onClick={() => onChangePage(pagination.page + 1)}
                        >
                            {t("content_analyze.next")}
                            <i className="icon-arrow-right1" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
}
